import { Opportunity, CampaignStatus, Contact } from '../models'

export default async function hasValidOpportunityFilter(
  opportunity: Opportunity,
  contact: Contact,
  filters
) {
  // date: this.loadingFilters.date,
  // endDate: this.loadingFilters.endDate
  let hasValidCampaign = true

  if (filters.campaignId) {
    // Discuss with Varun
    let campaignStatus = await CampaignStatus.getByCampaignIdAndStage(
      filters.campaignId,
      opportunity.pipelineStageId,
      opportunity.locationId
    )

    hasValidCampaign = Boolean(campaignStatus)
  }

  let hasSearchTerm = true
  if (filters.text) {
    hasSearchTerm = false

    if (
      opportunity.name &&
      opportunity.name.toLowerCase().includes(filters.text.toLowerCase())
    ) {
      hasSearchTerm = true
    } else if (opportunity.contactId && contact) {
      if (
        contact.fullName &&
        contact.fullName
          .toLowerCase()
          .includes(filters.text.toLowerCase())
      ) {
        hasSearchTerm = true
      } else if (
        contact.companyName &&
        contact.companyName
          .toLowerCase()
          .includes(filters.text.toLowerCase())
      ) {
        hasSearchTerm = true
      } else if (
        contact.email &&
        contact.email.toLowerCase().includes(filters.text.toLowerCase())
      ) {
        hasSearchTerm = true
      } else if (
        contact.tags &&
        contact.tags.length > 0 &&
        contact.tags.findIndex(x =>
          x.toLowerCase().includes(filters.text.toLowerCase())
        ) > -1
      ) {
        hasSearchTerm = true
      }
    }
  }

  return (
    (!filters.user || opportunity.assignedTo === filters.user) &&
    (!filters.currentLocationId ||
      opportunity.locationId === filters.currentLocationId) &&
    (!filters.pipelineId || opportunity.pipelineId === filters.pipelineId) &&
    (!filters.pipelineStageId ||
      opportunity.pipelineStageId === filters.pipelineStageId) &&
    (filters.status === 'all' || filters.status === opportunity.status) &&
    hasValidCampaign &&
    hasSearchTerm
  )
}
